import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import '@fontsource/roboto';
import SHButton from 'app/components/SHButton';
import { useNavigate } from 'react-router-dom';
import { ApiError, LandingPage, RiderService } from 'services/openapi';
import useApi from 'services/mavapi/useApi';
import Cookies from 'js-cookie';

// Icon assets from Figma design
const checkIconUrl =
  'https://www.figma.com/api/mcp/asset/a4db4910-8847-46bf-a08b-5d4f96a2e5ba';
const phoneIconUrl =
  'https://www.figma.com/api/mcp/asset/c16d5ef5-6309-41df-a003-8de5c687aba0';
const emailIconUrl =
  'https://www.figma.com/api/mcp/asset/597677a1-b319-4b87-8da9-8c2efac1704e';

const importantInfoItems = [
  'Only points accumulated while an active member enrolled in the Incentive Program will count toward scholarship distribution.',
  'The rider must be a YEDA member their Senior year of High School to receive a distribution',
  'Incentive Program points do not accrue until receipt of application and payment has been processed.',
];

const enrollmentFees = [
  { label: 'First-time application fee:', value: '$150' },
  { label: 'Annual sustaining cost:', value: '$75' },
  { label: 'EWD Members first time enrollment:', value: '$100' },
  { label: 'EWD Members sustaining fee:', value: '$25/year' },
];

type Props = {};

const SIF = (props: Props) => {
  const currentUserId = Cookies.get('userId');
  const { riderGetLandingPage } = RiderService;
  const { error: apiError, handleRequest } = useApi();
  const [, setError] = React.useState<ApiError | unknown>();
  const [sifDetails, setSifDetails] = React.useState<LandingPage>();
  const [enrolledDate, setEnrolledDate] = useState(false);
  const [loading, setLoading] = useState(true);

  function getSifDetails(id?: string) {
    handleRequest(riderGetLandingPage(id!))
      .then(res => {
        if (res) {
          Cookies.set('sifID', res?.id);
          Cookies.set('joinedDate', res?.sifJoinedDate);
          setSifDetails(res);
        }
        setLoading(false);
      })
      .catch(() => {
        setError(apiError);
        setLoading(false);
      });
  }

  React.useEffect(() => {
    getSifDetails(currentUserId);
    const joinedDateCookie = Cookies.get('hasSIFForSeason');
    setEnrolledDate(Boolean(joinedDateCookie));
  }, []);

  const navigate = useNavigate();

  const handleEnroll = () => {
    if (sifDetails) {
      const userRole = Cookies.get('userRole');
      const joinedDate = new Date(sifDetails?.sifJoinedDate!);
      if (sifDetails.hasSIFForSeason === false) {
        if (userRole === 'EWD') {
          navigate('/rider-landing-page/sif/ewd-new-enrollment');
        } else if (userRole === 'RIDER') {
          navigate('/rider-landing-page/sif/rider-new-enrollment');
        }
      } else if (
        sifDetails.hasSIFForSeason === true &&
        sifDetails?.sifJoinedDate !== null
      ) {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        if (userRole === 'EWD' && joinedDate < oneYearAgo) {
          navigate('/rider-landing-page/sif/ewd-sustaining-enrollment');
        } else if (userRole === 'RIDER' && joinedDate < oneYearAgo) {
          navigate('/rider-landing-page/sif/rider-sustaining-enrollment');
        }
      }
    }
  };

  const enrollLabel = sifDetails?.alreadyEnrolledInPastSeason
    ? 'Re-Enrol Now'
    : 'Enrol Now';

  return (
    <MainWrapper>
      {/* Header section */}
      <HeaderSection>
        <h1>Scholarship Incentive Fund (SIF)</h1>
        <p>
          YEDA is thrilled to continue the YEDA Scholarship Incentive Fund
          Program (SIF). Unlike other scholarship programs, YEDA recognizes an
          educational needs and desires far broader than those offered by
          traditional Secondary Education Programs.
        </p>
      </HeaderSection>

      {/* How to enroll steps */}
      {/* <EnrollSection>
        <SectionTitle>How to Enroll?</SectionTitle>
        <StepCards>
          <StepCard>
            <StepBadge color="#155dfc">01</StepBadge>
            <h3>Register as Member</h3>
            <StepItem>
              <img src={checkIconUrl} alt="" />
              <span>Register as a YEDA member</span>
            </StepItem>
            <StepItem>
              <img src={checkIconUrl} alt="" />
              <span>Voila! You're already a member</span>
            </StepItem>
          </StepCard>

          <StepCard>
            <StepBadge color="#4f39f6">02</StepBadge>
            <h3>Complete Application</h3>
            <StepItem>
              <img src={checkIconUrl} alt="" />
              <span>Complete the YEDA Scholarship Incentive Fund Application</span>
            </StepItem>
          </StepCard>

          <StepCard>
            <StepBadge color="#9810fa">03</StepBadge>
            <h3>Payment</h3>
            <StepItem>
              <img src={checkIconUrl} alt="" />
              <span>Register as a YEDA member</span>
            </StepItem>
            <StepItem>
              <img src={checkIconUrl} alt="" />
              <span>Voila! You're already a member</span>
            </StepItem>
          </StepCard>
        </StepCards>

        <EnrolButtonRow>
          {enrolledDate ? (
            <SHButton disabled={true}>Enrolled</SHButton>
          ) : (
            <SHButton onClick={handleEnroll}>{enrollLabel}</SHButton>
          )}
        </EnrolButtonRow>
      </EnrollSection> */}

      {/* Info cards row */}
      <InfoCardsRow>
        {/* Important Information card */}
        <ImportantCard>
          <ImportantCardTitle>Important Information</ImportantCardTitle>
          <BulletList>
            {importantInfoItems.map((item, i) => (
              <BulletItem key={i}>
                <BulletDot />
                <span>{item}</span>
              </BulletItem>
            ))}
          </BulletList>
          <ContactDivider />
          <ContactSection>
            <p className="contact-label">For inqueries, contact</p>
            <p className="contact-name">Terri Rafeld</p>
            <ContactLinks>
              <ContactLink>
                <img src={phoneIconUrl} alt="" />
                <span>419-564-5401</span>
              </ContactLink>
              <ContactLink>
                <img src={emailIconUrl} alt="" />
                <span>trafeld@showyeda.com</span>
              </ContactLink>
            </ContactLinks>
          </ContactSection>
        </ImportantCard>

        {/* About the Program card */}
        <AboutCard>
          <h2>About the Program</h2>
          <AboutText>
            The YEDA Scholarship Incentive Fund was designed to provide a
            vehicle for competing members to grow their continuing education
            dollars, based on their own individual performance. Dollars
            collected from members are placed in the designated YEDA Scholarship
            Incentive Fund account and coupled with additional scholarship
            contributions.
          </AboutText>
          <AboutText>
            Funds will be awarded to graduating Seniors based on the cumulative
            number of points earned during the years in which the member was
            enrolled in the Incentive Fund. YEDA competitors may enroll in the
            YEDA Scholarship Incentive Fund by paying a first-time application
            fee of $150.
          </AboutText>
          <FeesBox>
            <FeesTitle>Enrollment Fees</FeesTitle>
            <FeesList>
              {enrollmentFees.map((fee, i) => (
                <FeeRow key={i}>
                  <span>• {fee.label}</span>
                  <strong>{fee.value}</strong>
                </FeeRow>
              ))}
            </FeesList>
          </FeesBox>
          <EnrolButtonRow>
            {loading ? (
              <SkeletonBtn />
            ) : enrolledDate ? (
              <SHButton disabled={true}>Enrolled</SHButton>
            ) : (
              <SHButton onClick={handleEnroll}>{enrollLabel}</SHButton>
            )}
          </EnrolButtonRow>
        </AboutCard>
      </InfoCardsRow>

      {/* Detailed rules section */}
      {/* <RulesSection>
        <h3>Rules for Scholarship Incentive Fund (SIF)</h3>
        <p>
          The purpose of the YEDA Scholarship Incentive Fund (SIF) is to provide
          scholarship support to graduating seniors based on their competition
          performance over the period in which they were enrolled in the Fund.
          Points earned throughout the student/riders eligibility in YEDA will
          have a dollar value to be applied toward school or post education of
          choice.
        </p>
        <h5>How Do I Enrol?</h5>
        <p>
          Use the SIF enrollment form. The initial enrollment fee is one hundred
          and fifty dollars ($150). Each year after the re-enrollment sustaining
          cost is $75. The more points a student rider earns, the larger the
          portion of the funds he/she has the potential of earning. For EWD
          Members, first time enrollment is $100 and sustaining fee is $25 a
          year.
        </p>
        <h5>How Are Funds Created?</h5>
        <p>
          Enrollment and sustaining fees collected will remain with the
          graduating/future graduating class from which they were collected. In
          addition, a pot containing moneys collected for current year back
          numbers, current year YEDA show 50/50 raffles, current year SIF
          sponsorships and any other fund raising deemed appropriate will be
          split with 60% going to current year graduating class and 40% to be
          held back for the following year graduating class.
        </p>
        <h5>How Do I Earn SIF Dollars?</h5>
        <p>
          Points for SIF only build the years the rider is enrolled in SIF and
          only after the enrollment form and payment is received/post marked.
          Upon the rider's graduation year and/or last year of YEDA eligibility,
          all points earned while a member will be tallied and compared to the
          other SIF members in the graduating class.
        </p>
        <h5>How do I cash out my SIF dollars?</h5>
        <p>
          When an enrolled student/rider is in their graduating year or final
          year of YEDA eligibility, they will automatically receive a check from
          SIF. The check may be paid to the student's college, university, post
          educational institution of choice or directly to the student/rider.
        </p>
        <h5>What If SIF Is Replaced or Canceled?</h5>
        <p>
          In the unlikely event, the SIF program is replaced or canceled between
          competition seasons, refunds will occur in the following manner:
        </p>
        <ul>
          <li>
            Students enrolled the season prior to SIF cancelation will be
            reimbursed their enrollment and yearly sustaining fees collected to
            date.
          </li>
          <li>
            Any and all funds remaining in the SIF 60/40 pot will be distributed
            to previous season's enrollees.
          </li>
          <li>
            Any funds shortfall for the enrollment and sustaining fees will be
            paid from the YEDA general fund.
          </li>
        </ul>
      </RulesSection> */}
    </MainWrapper>
  );
};

const MainWrapper = styled.div`
  padding: 0 0 60px;
  min-height: 100%;
  width: 100%;
  background: transparent;
`;

const HeaderSection = styled.div`
  text-align: center;
  padding: 40px 80px 0;
  max-width: 900px;
  margin: 0 auto;

  h1 {
    font-size: 40px;
    font-weight: 700;
    color: #101828;
    margin: 0 0 16px;
    letter-spacing: 0.4px;
  }

  p {
    font-size: 18px;
    color: #4a5565;
    line-height: 1.65;
    margin: 0;
  }
`;

const EnrollSection = styled.div`
  padding: 48px 80px 0;
`;

const SectionTitle = styled.h2`
  font-size: 28px;
  font-weight: 600;
  color: #0a0a0a;
  text-align: center;
  margin: 0 0 32px;
`;

const StepCards = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
`;

const StepCard = styled.div`
  position: relative;
  flex: 1;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 14px;
  padding: 40px 24px 24px;

  h3 {
    font-size: 18px;
    font-weight: 600;
    color: #101828;
    margin: 0 0 16px;
  }
`;

const StepBadge = styled.div<{ color: string }>`
  position: absolute;
  top: -16px;
  left: -8px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: ${({ color }) => color};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 10px 15px rgba(0, 0, 0, 0.1);
`;

const StepItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 12px;
  color: #364153;
  font-size: 15px;
  line-height: 1.5;

  img {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    margin-top: 2px;
  }
`;

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: calc(400px + 100%) 0; }
`;

const SkeletonBtn = styled.div`
  width: 140px;
  height: 40px;
  border-radius: 8px;
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0.06) 25%,
    rgba(0, 0, 0, 0.12) 50%,
    rgba(0, 0, 0, 0.06) 75%
  );
  background-size: 800px 100%;
  animation: ${shimmer} 1.5s infinite linear;
`;

const EnrolButtonRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 28px;

  .button-wrapper .button {
    background: #155dfc !important;
    border-radius: 8px !important;
    padding: 10px 32px;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    min-width: 160px;
    height: auto;
  }
`;

const InfoCardsRow = styled.div`
  display: flex;
  gap: 24px;
  padding: 48px 80px 0;
`;

const ImportantCard = styled.div`
  width: 320px;
  flex-shrink: 0;
  border-radius: 14px;
  border: 2px solid #ffdf20;
  background: linear-gradient(
    125deg,
    rgb(255, 251, 235) 0%,
    rgb(254, 249, 194) 100%
  );
  padding: 24px;
`;

const ImportantCardTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #101828;
  margin: 0 0 20px;
`;

const BulletList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const BulletItem = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
  font-size: 14px;
  color: #1e2939;
  line-height: 1.6;
`;

const BulletDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #d08700;
  flex-shrink: 0;
  margin-top: 6px;
`;

const ContactDivider = styled.div`
  border-top: 1px solid #ffdf20;
  margin: 20px 0 16px;
`;

const ContactSection = styled.div`
  .contact-label {
    font-size: 13px;
    font-weight: 600;
    color: #101828;
    margin: 0 0 6px;
  }
  .contact-name {
    font-size: 15px;
    font-weight: 600;
    color: #ca3500;
    margin: 0 0 10px;
  }
`;

const ContactLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ContactLink = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #1e2939;

  img {
    width: 16px;
    height: 16px;
  }
`;

const AboutCard = styled.div`
  flex: 1;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 14px;
  padding: 32px;

  h2 {
    font-size: 22px;
    font-weight: 600;
    color: #101828;
    margin: 0 0 24px;
  }
`;

const AboutText = styled.p`
  font-size: 15px;
  color: #364153;
  line-height: 1.65;
  margin: 0 0 16px;
`;

const FeesBox = styled.div`
  background: #eff6ff;
  border-left: 4px solid #155dfc;
  border-radius: 4px;
  padding: 16px 16px 16px 20px;
  margin-top: 20px;
`;

const FeesTitle = styled.h4`
  font-size: 15px;
  font-weight: 600;
  color: #101828;
  margin: 0 0 12px;
`;

const FeesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const FeeRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #364153;

  strong {
    font-weight: 600;
  }
`;

const RulesSection = styled.div`
  padding: 40px 80px 0;

  h3 {
    font-size: 20px;
    font-weight: 600;
    color: #0a0a0a;
    padding-top: 20px;
    margin: 0 0 12px;
  }

  h5 {
    font-size: 15px;
    font-weight: 600;
    color: #0a0a0a;
    margin: 20px 0 8px;
  }

  p {
    font-size: 14px;
    color: #364153;
    line-height: 1.7;
    margin: 0 0 12px;
  }

  ul {
    padding-left: 24px;
    margin: 8px 0 16px;

    li {
      font-size: 14px;
      color: #364153;
      line-height: 1.7;
      margin-bottom: 6px;
    }
  }
`;

export default SIF;
